import React from 'react';
import classnames from 'classnames';

import ActionButton from 'jbc-front/components/ActionButton';
import { CheckCircle, Excluded } from 'jbc-front/components/icons';

import { EditActionBtn, CancelActionBtn, SaveActionBtn } from 'src/buttons';
import { EMPLOYEE_SHOW } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';

import styles from './RevisionItemHeader.scss';

const RevisionItemHeader = props => {
  const { revision, formRevision } = props;
  const showMode = () => props.showMode(revision);
  const changeToEditMode = () => props.changeToEditMode(revision);
  const cancel = () => props.cancel(revision);
  const save = () => props.save(revision);
  const reset = () => props.reset(revision);
  const isSubject = showMode(revision) === 'SHOW' ? revision.isSubject : formRevision.isSubject;

  return (
    <div className={styles.container}>
      <div className={styles.labels}>
        <div className={styles.item}>
          スタッフコード{'　'}: <span className={styles.code}>{revision.staffCode}</span>
        </div>
        <div className={styles.item}>
          氏名{'　'}:{' '}
          <span className={styles.name}>
            <a href={concatParamsToUrl(EMPLOYEE_SHOW, { id: revision.employeeId })}>
              {revision.lastName} {revision.firstName}
            </a>
          </span>
        </div>
        <div className={styles.subject}>
          <div className={classnames(styles.subjectState, isSubject ? styles.isSubject : styles.isNotSubject)}>
            {isSubject ? (
              <React.Fragment>
                <CheckCircle size={16} className={styles.icon} />対象
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Excluded size={16} className={styles.icon} />対象外
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
      {showMode() === 'SHOW' ? (
        <div className={styles.action}>
          <EditActionBtn onClick={() => changeToEditMode()} />
        </div>
      ) : (
        <div className={styles.action}>
          <ActionButton onClick={() => reset()} as="button" className="u-mr10">
            手入力前に戻す
          </ActionButton>
          <SaveActionBtn onClick={() => save()} className="u-mr10" />
          <CancelActionBtn onClick={() => cancel()} />
        </div>
      )}
    </div>
  );
};

export default RevisionItemHeader;
